/**
 * Landing demo 麥克風擷取的共用約束:關閉 echoCancellation / noiseSuppression /
 * autoGainControl,對齊 desktop(cpal)的原始擷取。這些瀏覽器前處理在純語音聽寫時
 * 常劣化辨識(AGC 音量忽大忽小、NS 削掉語音邊緣),是 web demo 與 desktop 辨識品質
 * 差異的來源之一。
 *
 * demo card 開共享 stream、以及兩個擷取 hook(use-mic-recorder / use-pcm-stream)的
 * own-stream fallback 都用同一份約束,確保「不論走哪條路徑」拿到的都是同品質的原始
 * 音訊 — 約束屬於擷取層,不該只存在單一呼叫端。
 */
export const DEMO_MIC_CONSTRAINTS: MediaStreamConstraints = {
  audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false },
}
